import type { IDetailsRowCheckStyles } from '@fluentui/react';

export const getDetailsRowCheckStyles = (): Partial<IDetailsRowCheckStyles> => ({
  check: [
    {
      opacity: 1,
    },
  ],
});
